import * as React from "react";
import type { SVGProps } from "react";
const SvgBabySitterReccomendationIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <g clipPath="url(#baby-sitter-reccomendation-icon_svg__a)">
      <path
        fill="#858585"
        d="M16.275-.035a.6.6 0 0 0-.14.035.5.5 0 0 0-.14.053s-.685.352-1.312 1.137c-.563.702-1.099 1.792-1.208 3.308-.053.002-.105.015-.157.017-.368-1.146-1.293-1.763-2.1-2.03-.902-.297-1.733-.245-1.733-.245h-.053a.563.563 0 1 0 .123 1.12s.64-.03 1.313.193c.538.179 1.04.474 1.312 1.085-5.257.78-9.338 4.88-9.835 10.01C1.028 14.873 0 15.982 0 17.36c0 1.328.963 2.395 2.205 2.678.728 2.771 2.41 4.78 4.515 6.055C8.912 27.42 11.524 28 14 28s5.088-.58 7.28-1.907c2.104-1.276 3.787-3.284 4.515-6.055C27.037 19.755 28 18.688 28 17.36c0-1.378-1.028-2.487-2.345-2.712-.534-5.528-5.237-9.862-11.077-10.133.098-1.26.546-2.085.98-2.625.492-.612.927-.822.927-.822a.561.561 0 0 0-.21-1.103M13.895 5.6q.088.013.175 0c5.677.035 10.246 4.268 10.535 9.555l.035.525h.56c.934 0 1.68.746 1.68 1.68 0 .893-.68 1.6-1.557 1.663l-.42.035-.088.402c-.606 2.66-2.14 4.49-4.113 5.688-1.973 1.196-4.4 1.732-6.702 1.732s-4.73-.536-6.702-1.732C5.324 23.95 3.79 22.12 3.185 19.46l-.087-.402-.42-.035A1.66 1.66 0 0 1 1.12 17.36c0-.934.746-1.68 1.68-1.68h.56l.035-.525c.27-4.922 4.252-8.925 9.38-9.485a.56.56 0 0 0 .367-.035c.25-.02.497-.033.753-.035M9.52 14.56a1.68 1.68 0 1 0 0 3.36 1.68 1.68 0 0 0 0-3.36m8.96 0a1.68 1.68 0 1 0 0 3.36 1.68 1.68 0 0 0 0-3.36m-7.91 6.825a.56.56 0 0 0-.28.997S11.732 23.52 14 23.52s3.71-1.137 3.71-1.137a.56.56 0 1 0-.7-.875s-1.103.892-3.01.892c-1.908 0-3.01-.892-3.01-.892a.56.56 0 0 0-.42-.123"
      />
    </g>
    <defs>
      <clipPath id="baby-sitter-reccomendation-icon_svg__a">
        <path fill="#fff" d="M0 0h28v28H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBabySitterReccomendationIcon;
